// App.js
// import './App.css';
import { useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';
import AppMain from './AppMain';
import MapMain from './MapMain';
import UserSessionInfo from './com/common/UserSessionInfo';
import { Waiting, ErrorBox } from './com/message/Waiting';
import { CvoMsg, AppObject, AppWord, MapValue } from './model/AppConst';
import {mapLinkInfoRepo, mmlog, userInfoRepo} from './model/CvoModel';
import {useLazyQuery, useReactiveVar} from '@apollo/client';
import {GET_SESSION_DATA, MAP_LINK_LOGIN} from './com/session/SessionGql';
import ValueUtil from './model/ValueUtil';
//import { MENU_TREE } from './com/menu/MenuGql';

function parseUrlIfMapLink() {
    if(window.location.href.indexOf("ci=") > 10 && window.location.href.indexOf("ed=") > 10) {
        // window.location.search is a JavaScript property that returns the
        // query string portion of the current URL, including the leading question mark (?).
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get("ci") !== null && urlParams.get("ed") !== null) {
            const custId = urlParams.get("ci");
            const encodedData = urlParams.get("ed");
            const aes = urlParams.get("em")==='B' ? false : true; // A[ES128], B[Base64]
            const mobile = urlParams.get("m") === 'Y';
            return {custId, encodedData, aes, mobile};
        }
    }
    return null;
}

function App() {
    //const [checkSession, {loading, error, data, called}]
    //    = useLazyQuery(GET_SESSION_DATA, AppObject.NoCachedFetch);
    const [mapLinkError, setMapLinkError] = useState(null);
    const [checkError, setCheckError] = useState(null);
    const sessionInfo = useReactiveVar(userInfoRepo);
    const [isMapApp, setIsMapApp] = useState(window.location.href.indexOf("view=map") > 1);
    const [snackBars, setSnackBars] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [messageInfo, setMessageInfo] = useState(undefined);
    const [checkSession, responseCheck] = useLazyQuery(GET_SESSION_DATA,
        {
            ...AppObject.NoCachedFetch,
            onCompleted: (data, option) => {onCompletionCheckSession(data, option);},
            onError: (error) => {
                setCheckError(error);
            }
        }
    );
    const [mapLinkLogin, responseMapLinkLogin] = useLazyQuery(MAP_LINK_LOGIN, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteMapLinkLogin(data, option);},
        onError: (error) => {
            setMapLinkError("지도 링크 로그인에 실패했습니다. 잠시후 다시 시도해 주세요.");
            sessionInfo.ifLocal(()=>console.error("Map link login error:", error));
        }
    });

    /*

    const [getUserInfoItemToEdit, responseItemToEdit] = useLazyQuery(GET_USER_INFO,
        {
            ...AppObject.NoCachedFetch,
            onCompleted: (data, option) => {onCompleteGetItem(data, option)},
            onError: (error) => {setResponseAlert({open:true, error: error, title: ErrorTitle.Get})}
        });
    */
    // 지도를 띄우는지 확인해서 설정할 필요.
    useEffect(() => {
        document.title = '차량관제-eTrace';
        mmlog("App started.");
        /*
        추가할 내용:
        - 외부업체에서 지도링크로 접근하는 경우 입력된내용을 바탕으로 서버에 별도 세션작업을 요청해야 함. (ci,ed,em,m)
        - ci=custId, ed=encoded_data, em=encoding_method(A[ES128], B[Base64]), m=Y/N(is-mobile)
        - 서버에서 세션을 생성하고, 세션정보와 ed에 들어있는 내용을 분석하여 작업할 내용을 함께 반환.
         */
        const mapLinkData = parseUrlIfMapLink();
        if(mapLinkData) {
            mmlog("Map link detected. custId=" + mapLinkData.custId);
            // 서버에 세션 요청을 하고, 받은 세션정보를 저장해야 함.
            mapLinkLogin({
                variables: {
                    custId: mapLinkData.custId,
                    encodedData: mapLinkData.encodedData,
                    aes: mapLinkData.aes,
                    mobile: mapLinkData.mobile
                }
            });
        }
        else checkSession(); // mapLink일 경우에는 세션 체크할 필요 없음.
    }, []);

    useEffect(() => {
        const onBubbleSnack = (event) => {
            const snacks = [...snackBars];
            const {detail} = event;
            snacks.push({...detail});
            setSnackBars(snacks);
        };

        document.addEventListener(AppWord.SNACK_EVENT, onBubbleSnack);
        return () => {document.removeEventListener(AppWord.SNACK_EVENT, onBubbleSnack);};
    }, []);

    const onCompletionCheckSession = (data, option) => {
        if(data.getSessionData) {
            const isSignedIn = data.getSessionData.user.msg===CvoMsg.OK;
            /* userInfoRepo({
                ...data.getSessionData,
                signedIn: isSignedIn,
                sessionChecked: true
            }); */
            userInfoRepo(new UserSessionInfo(true, isSignedIn, data.getSessionData));
        }
    };

    const onCompleteMapLinkLogin = (data, option) => {
        if(data.mapLinkLogin) {
            const {msg, mapShowJob, sessionData} = data.mapLinkLogin;
            if(msg === CvoMsg.OK) {
                // userInfoRepo(new UserSessionInfo(true, true, data.login));
                userInfoRepo(new UserSessionInfo(true, true, sessionData));
                // Repair if ...
                if(mapShowJob.show === MapValue.Show.route) {
                    mapShowJob.from = ValueUtil.repairYmdHmsText(mapShowJob.from);
                    mapShowJob.till = ValueUtil.repairYmdHmsText(mapShowJob.till);
                }
                if(mapShowJob.mapLevel !== undefined && mapShowJob.mapLevel !== null) {
                    mapShowJob.mapLevel += MapValue.Level.ZOOM_LEVEL_DELTA;
                }
                else mapShowJob.mapLevel = MapValue.Level.ZOOM_INIT;
                mapLinkInfoRepo(mapShowJob);
                // mapShowJob 정보를 사용해서 다음에 할 일들을 설정한다.
                // mapShowJob.show: veh | route | [position:default]
                /*
                veh: 특정 차량의 위치로 지도 중심을 이동하게 함. (vehId)
                route: 특정 차량의 경로를 보여주게 함. (vehId, from, till). from, till: YYYYMMDD HHmmss.
                position: 모든 차량의 위치를 보여주게 함. 특별히 할 일 없음.
                */
                setIsMapApp(true);
            }
            else {
                // 로그인 실패시 화면에 크게 보여준다.
                setMapLinkError(msg);
            }
        }
        else {
            setMapLinkError("지도 링크 로그인에 실패했습니다. 서버에서 응답이 없습니다.");
        }
    };

    useEffect(() => {
        if (snackBars.length && !openSnackbar) {
            // Set a new snack when we don't have an active one
            setMessageInfo(snackBars.shift());
            setSnackBars([...snackBars]);
            setOpenSnackbar(true);
        }
        else if (snackBars.length && messageInfo && openSnackbar) {
            // Close an active snack when a new one is added
            setOpenSnackbar(false);
        }
    }, [snackBars, messageInfo, openSnackbar]);

    const closeSnackBar = () => {
        setOpenSnackbar(false);
    };

    if(mapLinkError) {
        return <ErrorBox messages={[
            "지도 링크로 접근하는 과정에서 오류가 발생했습니다.",
            mapLinkError
        ]} />;
    }

    // if(loading) return <Waiting message="로그인 상태 점검중입니다."/>;
    if(checkError) return <ErrorBox messages={[
        "로그인 상태 점검중 오류가 발생했습니다.",
        "잠시 후 다시 시도해 주세요."]} />;

    // const isMapApp = window.location.href.indexOf("view=map") > 1;

    if(sessionInfo.sessionChecked) {
        return (
            <>
            {
                isMapApp ? <MapMain /> : <AppMain />
            }
            <Snackbar
                open={openSnackbar}
                autoHideDuration={messageInfo && messageInfo.duration ? messageInfo.duration : 5000}
                onClose={closeSnackBar}
                message={messageInfo ? messageInfo.message : 'Undefined message'}
                anchorOrigin={messageInfo && messageInfo.anchorOrigin ? messageInfo.anchorOrigin : {vertical:'bottom', horizontal:'center'}}
                sx={messageInfo ? messageInfo.sx : undefined}
            />
            </>
        );
    }
    else {
        return(<Waiting message="로그인 상태 점검중입니다......"/>);
    }
}

export default App;

/*
TODO: (지도)
- 지점그룹 조회, 생성, 수정, 삭제 - poi_group
- 지도에서 지점그룹 있는 경우 사용자별 지점그룹 매핑을 저장, 삭제하는 기능 - user_poi_group_map
- 지점그룹 사용하는 경우 지점그룹과 지점을 연결, 연결해제하는 기능 - 기존 지점정보 생성, 편집에 지점그룹 선택하는 기능 추가(if poi_by_group_cd==='SINGLE')
- 지점그룹 사용하는 경우 사용자에 매핑된 지점그룹의 지점들만 지도에 표시. (그룹사용판단은 세션의 poiByGroupCd 값이 SINGLE인 경우)
    - user_poi_group_map
    - poi_group_map

TODO 2024-04-25:
- 알람 송신을 위한 텍스트 템플릿 설정 (cust_alarm_msg)
- 차량별 도착지점 설정에서 CSV 처리 로직에 출발, 도착 알림을 설정할 수 있도록 하기. (현재는 항상 도착알림) 

Queries:
getSessionData: SessionData
login(userId: String!,password: String!): SessionData
loginAs(userId: String!): SessionData
logout: SessionData
actLogList(sessionKey: String,regUserId: String): [ActLog]!
actLogListLogin(timeFrom: String,timeTill: String): [ActLog]!
addressGroupList: [AddressGroup]!
addressInfoList: [AddressInfo]!
addressInfoItem(addressId: Int): AddressInfo
alarmTypeList: [AlarmType]!
bcdIoDataList(timeFrom: String,timeTill: String): [BcdIoData]!
bcdIoDataListForVehicle(vehId: Int,timeFrom: String,timeTill: String): [BcdIoData]!
bcdIoDataListForPoi(poiId: Int,timeFrom: String,timeTill: String): [BcdIoData]!
bcdNoticeMoreList: [BcdNoticeMore]!
bcdNoticeMoreItem(vehId: Int,poiId: Int): BcdNoticeMore
codeTree: [CodeType!]!
codeDetailList(cdType: String): [CodeDetail!]!
cruiseLogListForVeh(vehId: Int): [CruiseLog]!
cruiseLogListForPoi(poiId: Int): [CruiseLog]!
custAgreeList: [CustAgree]!
custAgreeListAll(custId: String): [CustAgree]!
custAgreeItem(groupId: Int!): CustAgree
custAgreeListGiving: [CustAgree]!
custAgreeItemGiving(custId: String!,groupId: Int!): CustAgree
custAgreeListForUser(userId: String!): [CustAgree]!
custGetAlarmList: [CustGetAlarm]!
custGetAlarmItem(alarmTypeId: Int,mobile: String): CustGetAlarm
custGetAlarmListForAlarm(alarmTypeId:Int): [CustGetAlarm]!
custGetAlarmListForMobile(mobile:String): [CustGetAlarm]!
custHistoryList(custId: String): [CustHistory]!
custHistoryItem(custId: String,recId: Int): CustHistory
custInfoList: [CustInfo]!
custInfoItem(custId: String): CustInfo
custOwnCodeTree: [CustOwnCodeKind]!
custPeopleList(custId: String!): [CustPeople]!
custPeopleItem(custId: String!,recId: Int!): CustPeople
custPoiTypeList: [CustPoiType]!
custPoiTypeItem(poiType: Int): CustPoiType
cvoFileList(forWhom: String): [CvoFile]!
cvoFileItem(fileNid: Int): CvoFile
getArchiveList: [Download]!
downloadFileList(msgSeq: Int): [DownloadFile]!
downloadFileItem(msgSeq: Int,fileNid: Int): DownloadFile
downloadInfoList: [DownloadInfo]!
downloadInfoItem(msgSeq: Int): DownloadInfo
dtgMakersList: [DtgMakers]!
dtgModelsList: [DtgModels]!
groupVehAllocList: [GroupVehAlloc]!
groupVehAllocListOf(vehId: Int,groupId: Int): [GroupVehAlloc]!
groupVehAllocItem(vehId: Int,groupId: Int): GroupVehAlloc
iconPoolList: [IconPool]!
menuToUserTree: [MenuKind]!
menuToUserTreeForSelection(userId: String!): [MenuKind]!
naverSearchRoute(searchInput: NaverRouteArgDto!): ResponseWithRoute!
notifyBoardList: [NotifyBoard]!
notifyBoardItem(msgSeq: Int!): NotifyBoard
notifyFileList(msgSeq: Int): [NotifyFile]!
notifyFileItem(msgSeq: Int,fileNid: Int): NotifyFile
poiGroupList: [PoiGroup]!
poiGroupItem(groupNid: Int!): PoiGroup
poiInfoList: [PoiInfo]!
poiInfoListForMap: [PoiInfo]!
poiInfoItem(poiId: Int): PoiInfo
getPosReportLog(routeDate: String): [PosReportLog]!
getPosReportNotiLog: [PosStatViewLog]!
getPosDownloadLog: [PosDownloadLog]!
getServiceLog(svcTime: String): [ServiceLog]!
getPosUsageLog: [PosStatViewLog]!
getSessionLog(actDate: String): [SessionLog]!
routeDailyList(dateFrom: String,dateTill: String): [RouteDaily]!
routeDailyBillList(routeDate: String): [RouteDailyBill]!
routeHourlyList(date: String): [RouteHourly]!
routeHourlyListOff(date: String): [RouteHourlyAllowed]!
routeMonthlyList(routeDate: String!): [RouteMonthly]!
routeMonthlyListOfVeh(vehId: Int!,dateFrom: String!,dateTill: String!): [RouteMonthly]!
routineDistribLogListForVeh(vehId: Int): [RoutineDistribLog]!
routineDistribLogListForPoi(poiId: Int): [RoutineDistribLog]!
smsMessageList(dateFrom: String,dateTill: String): [SmsMessage]!
smsPhraseList: [SmsPhrase]!
smsPhraseItem(phraseId: Int!): SmsPhrase
sweeperStatList(routeDate: String!): [SweeperStat]!
termChangeLogList(termId: String): [TermChangeLog]!
termInfoList(custId: String): [TermInfo]!
termInfoListAvailable(custId: String): [TermInfo]!
termInfoItem(devId: Int): TermInfo
termMakerInfoList: [TermMakerInfo]!
termMngList(termMngSearch: InputTermMngSearch!): [TermMng]!
termMngItem(termMngSeq: Int!): TermMng
termMngCustList: [TermMngCust]!
termMngLogList(termMngLogSearch: InputTermMngLogSearch!): [TermMngLog]!
termMngLogItem(logNid: Int!): TermMngLog
termMngLogCustList: [TermMngLogCust]!
termModelInfoList: [TermModelInfo]!
termStateLogList(devId: Int): [TermStateLog]!
termStockList(dateFrom: String!,dateTill: String!): [TermStock]!
termStockListSum: [TermStock]!
termStockListAt(ioDate: String!): [TermStock]!
termStockItem(ioDate: String!,modelId: Int!): TermStock
termsStatList: [TermsStat]!
termsStatItem(custId: String): TermsStat
termsStatTotal: TermsStat
userGetAlarmList(userId: String): [UserGetAlarm]!
userInfoList(custId: String): [UserInfo]!
userInfoListOverGroup(groupId: Int!): [UserInfo]!
userInfoItem(userId: String!): UserInfo
userPoiGroupMapList: [UserPoiGroupMap]!
userPoiGroupMapItem(groupNid: Int): UserPoiGroupMap
userPoiRelationPoiListForUser(userPoiRel: String,userId: String): [UserPoiRelation]!
userPoiRelationUserListForPoi(userPoiRel: String,poiId: Int): [UserPoiRelation]!
userTcolConf21List: [UserTcolConf21]!
userTcolConf21Item(viewName: String!): UserTcolConf21
vehConfList: [VehConf]!
vehConfItem(vehId: Int): VehConf
vehGroupList(custId: String): [VehGroup]!
vehGroupListForVeh(vehId: Int!): [VehGroup]!
vehGroupListForUser(userId: String!): [VehGroup]!
vehGroupItem(groupId: Int!): VehGroup
vehGroupBcdMapList: [VehGroupBcdMap]!
vehGroupBcdMapListForPoi(poiId: Int): [VehGroupBcdMap]!
vehGroupBcdMapItem(groupId: Int,poiId: Int): VehGroupBcdMap
vehInfoList(custId: String): [VehInfo]!
vehInfoItem(custId: String,vehId: Int!): VehInfo
vehInfoListOverGroup(groupId: Int!): [VehInfoOverGroup]!
vehInfoListInGroup(groupId: Int!): [VehInfoOverGroup]!
vehInfoListEditable: [VehPlatesInfo]!
canUserEdit(vehId: Int!): UserCanEditVehInfoVo!
vehReportStatItem(custId: String): VehReportStat
vehInfoLogList(vehId: Int!,custId: String): [VehInfoLog]!
vehItinList(vehId: Int,timeFrom: String,timeTill: String): [VehItin]!
vehPosList: [VehPos]!
vehTemprList: [VehTempr]!
vehRouteList(vehId: Int,timeFrom: String,timeTill: String): [VehRoute]!
vehRouteTemprList(vehId: Int,timeFrom: String,timeTill: String): [VehRouteTempr]!
vehTonInfoList(custId: String): [VehTonInfo]!
vehTonInfoItem(vehTonId: Int): VehTonInfo
vehTypeInfoItem(vehTypeId: Int): VehTypeInfo
viewCruiseList: [ViewCruise]!
viewRoutineDistribList: [ViewRoutineDistrib]!
viewTelecomStatusList(custId: String): [ViewTelecomStatus]!


*/